import { useParams } from 'react-router-dom';
import { Dispatch, SetStateAction } from 'react';
import { GenericDrawer } from '@dealstack/frontend/shared/components/GenericDrawer/GenericDrawer';
import { useTranslationAdminDashboard } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { Classifier } from '@dealstack/frontend/app/pages/Project/DealSettings/Classifiers/types';
import { DrawerBodyCreate } from '@dealstack/frontend/app/pages/Project/DealSettings/Classifiers/CreateClassifierDrawer/DrawerBodyCreate';
import { useGetDealClassifiers } from '@dealstack/frontend/app/pages/Project/DealSettings/Classifiers/hooks/useGetDealClassifiers';
import { getAllClassifiersFilter } from '@dealstack/frontend/app/pages/Project/DealSettings/Classifiers/EditClassifierDrawer/utils';

interface Props {
	classifier: Classifier;
	showCreateUpdateClassificationDrawer: boolean;
	handleOnCancel: () => void;
	setShowCreateUpdateClassificationDrawer: Dispatch<SetStateAction<boolean>>;
}

export const CreateClassifierDrawer = ({
	classifier,
	showCreateUpdateClassificationDrawer,
	handleOnCancel,
	setShowCreateUpdateClassificationDrawer,
}: Props) => {
	const tAdminDashboard = useTranslationAdminDashboard();
	const { dealId } = useParams();

	const { classifiers: availableClassifiers } = useGetDealClassifiers(
		getAllClassifiersFilter(dealId ?? '')
	);

	return (
		<GenericDrawer
			onClose={handleOnCancel}
			opened={showCreateUpdateClassificationDrawer}
			title={tAdminDashboard('drawer.create_classifier.title')}
			body={DrawerBodyCreate({
				classifier,
				handleOnCancel,
				availableClassifiers: availableClassifiers?.payload?.dealClassifiers,
				setShowCreateUpdateClassificationDrawer,
			})}
		/>
	);
};
